import { Observable } from 'rxjs';
import { NgFor, NgIf } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { FormsModule } from '@angular/forms';
import { PQRAdicionaisDto } from '../../dtos';
import { maskitoTransform } from '@maskito/core';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { EtapasDeEdicaoService } from '../../services/';
import { mask_porcentagem_limpa } from '../../directives/mascaras';
import { TabelaComponent } from '../../shared/tabela/tabela.component';
import { NoLeftZeroDirective } from '../../directives/no-left-zero.directive';
import { OnlyNumbersDirective } from '../../directives/only-numbers.directive';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { MenuSuspensoComponent } from '../../shared/menu-suspenso/menu-suspenso.component';
import { ModalInconsistenciaComponent } from '../../shared/modal-inconsistencia/modal-inconsistencia.component';
import { DialogPqrAdicionaisComponent } from '../../shared/dialog-pqr-adicionais/dialog-pqr-adicionais.component';
import { IconeAtivo, LayoutEditorContentService } from '../../layouts/layout-editor/layout-editor-content.service';
import { PrecoEncargosAdicionaisStateService } from '../../services/preco-encargos-adicionais-state/preco-encargos-adicionais-state.service';
import {
  caminhoImagemLateralPrecoEncargosAdicionais,
  corFundoLateralPrecoEncargosAdicionais,
  opcoesMenusLateralAtivasPrecoEncargosAdicionais,
  opcoesMenuLateralPrecoEncargosAdicionaisInativas,
  tituloMenuLateralPrecoEncargosAdicionais
} from '../../layouts/layout-editor/template/lateral-navegacao-preco-encargos-adicionais';
import { MaskitoDirective } from '@maskito/angular';
import { BasePqrComponent } from '../base-pqr/base-pqr.component';
import { ValidadorTela } from '../../interfaces/validacao.interface';
import { FeatureFlagService } from '../../services/feature-flag/feature-flag.service';

const DESCRICAO_ITEM_LEGADA = 'Adicional de remuneração para professores das escolas rurais';
const DESCRICAO_ITEM_NOVA = 'Adicional de remuneração para profissionais das escolas do campo';

interface PQRAdicionaisTable {
  id: number;
  descricaoItem: string;
  percentual: string;
}

@Component({
  selector: 'app-adicionais',
  standalone: true,
  imports: [
    NgFor,
    NgIf,
    MatTooltip,
    TabelaComponent,
    MatIconModule,
    MatTooltip,
    FormsModule,
    TabelaComponent,
    MenuSuspensoComponent,
    NoLeftZeroDirective,
    OnlyNumbersDirective,
    MaskitoDirective,
  ],
  templateUrl: './adicionais.component.html',
  styleUrl: './adicionais.component.scss',
})
export class AdicionaisComponent extends BasePqrComponent<PQRAdicionaisDto> implements OnInit, ValidadorTela {

  protected valoresPadrao: PQRAdicionaisDto[] = [];
  protected valoresEdicao: PQRAdicionaisDto[] = [];

  mostrarInconsistencia: boolean = false;
  usuarioQuerSair: boolean = false;

  mask_porcentagem_limpa = mask_porcentagem_limpa;
  dadosTabela: PQRAdicionaisTable[] = [];

  constructor(
    router: Router,
    toastr: ToastrService,
    private dialog: MatDialog,
    private dialogPqrAdicionais: MatDialog,
    dialogRestaurarValoresPadrao: MatDialog,
    private etapasDeEdicaoService: EtapasDeEdicaoService,
    private layoutEditorContentService: LayoutEditorContentService,
    private precoEncargosAdicionaisStateService: PrecoEncargosAdicionaisStateService,
    public featureFlagService: FeatureFlagService,
  ) {
    super(router, toastr, dialogRestaurarValoresPadrao, dialogPqrAdicionais);
    this.layoutEditorContentService.definirIconeAtivo(IconeAtivo.MOEDAS);
    this.layoutEditorContentService.definirTituloMenuLateral(
      tituloMenuLateralPrecoEncargosAdicionais,
    );
    const opcoesAtivas = opcoesMenusLateralAtivasPrecoEncargosAdicionais.map((opcao) =>
      opcao.caminho === '/condicao-qualidade/docente-adicional-remuneracao'
        ? { ...opcao, rotulo: 'Adicional de remuneração' }
        : opcao,
    )
    this.layoutEditorContentService.definirOpcoesAtivas(opcoesAtivas);
    this.layoutEditorContentService.definirOpcoesInativas(
      opcoesMenuLateralPrecoEncargosAdicionaisInativas,
    );
    this.layoutEditorContentService.definirCaminhoImagem(
      caminhoImagemLateralPrecoEncargosAdicionais,
    );
    this.layoutEditorContentService.definirCorFundoMenuLateral(
      corFundoLateralPrecoEncargosAdicionais,
    );
    this.layoutEditorContentService.definiOpcaoAtivaSelecionada(1);
    this.layoutEditorContentService.definirExibirBotaoAnterior(true);
    this.layoutEditorContentService.definirRotaAnterior(
      '/relatorio2/condicao-qualidade/direitos-obrigacoes-trabalhistas',
    );
    this.layoutEditorContentService.definirExibirBotaoProximo(true);
    this.layoutEditorContentService.definirRotaProximo(
      '/relatorio2/resultado-previsao-orcamentaria',
    );
  }

  ngOnInit(): void {
    if (this.precoEncargosAdicionaisStateService.carregando.getValue()) {
      this.precoEncargosAdicionaisStateService.carregando.subscribe(() => {
        this.carregarDadosInterno();
        return;
      });
      return;
    }

    this.carregarDadosInterno();
  }

  private carregarDadosInterno() {
    this.carregarDados(
      () => this.precoEncargosAdicionaisStateService.getPQRAdicionaisPadrao(),
      () => this.precoEncargosAdicionaisStateService.getPQRAdicionaisValores()
    );
    this.processarDadosTabela(this.valoresEdicao);
  }

  private processarDadosTabela(dados: PQRAdicionaisDto[]): void {
    this.dadosTabela = dados.map((dado) => {
      const dadoTabela: PQRAdicionaisTable = {
        id: dado.codPqrAdicionaisManutencaoEncargos,
        descricaoItem: dado.descricaoItem,
        percentual: maskitoTransform(
          String(dado.percentual),
          mask_porcentagem_limpa,
        ),
      };
      return dadoTabela;
    });
  }

  atualizarDadosDoServicoDeEstado(item:PQRAdicionaisTable,percentualEditado: string): void {
    const dados = this.dadosTabela.map((tabela) => {
      const dto: PQRAdicionaisDto = {
        codPqrAdicionaisManutencaoEncargos: tabela.id,
        descricaoItem: tabela.descricaoItem,
        percentual: item.id === tabela.id ?
          Number(percentualEditado.replace(',', '.')) :
          Number(tabela.percentual.replace(',', '.'))
      };
      return dto;
    });

    this.valoresEdicao = dados;
    this.atualizarValores();
  }

  protected atualizarValores() {
    this.precoEncargosAdicionaisStateService.setPQRAdicionaisValores(this.valoresEdicao);
  }

  obterDescricaoItem(dados: PQRAdicionaisTable): string {
    if (
      dados.descricaoItem === DESCRICAO_ITEM_LEGADA
    ) {
      return DESCRICAO_ITEM_NOVA;
    }
    return dados.descricaoItem;
  }

  abrirDialog(proximaRota: RouterStateSnapshot): void {
    this.toastr.error('Verifique as inconsistências.', 'Atenção!');

    const data = {
      mensagens: this.criaMensagemInconsistencia(),
      proximaRota: proximaRota.url,
    };

    const dialogRef = this.dialog.open(ModalInconsistenciaComponent, {
      data: data,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'sim') {
        this.usuarioQuerSair = true;
        this.router.navigate([proximaRota.url]);
      }
    });
  }

  protected openDialogPqrValoresPadrao(): void {
    const dialogRef = this.dialogPqrAdicionais.open(
      DialogPqrAdicionaisComponent,
      {
        panelClass: 'dialog-pqr-adicionais',
      },
    );
    dialogRef.componentInstance.dadosTabela =
      this.precoEncargosAdicionaisStateService.getPQRAdicionaisPadrao();
  }

  public criaMensagemInconsistencia(): string[] {
    const mensagens: string[] = [];
    this.dadosTabela.forEach((dado) => {
      const percentual: number = Number(dado.percentual.replace(',', '.'));
      if (percentual < 0 || percentual > 100) {
        mensagens.push(
          `O valor do percentual para o item ${dado.descricaoItem} não é válido.Informe um valor de 0% a 100%`,
        );
      }
    });

    return mensagens;
  }
}

export function canDeactivateFnAdicionais
(component: AdicionaisComponent,
  currentRoute: ActivatedRouteSnapshot,
  currentState: RouterStateSnapshot,
  nextState?: RouterStateSnapshot,
): Observable<boolean> | boolean {
  if (
    component.criaMensagemInconsistencia().length > 0 &&
    !component.usuarioQuerSair
  ) {
    if (nextState) {
      component.abrirDialog(nextState);
    }
    component.mostrarInconsistencia = true;
    component.mensagensInconsistencia = component.criaMensagemInconsistencia();
    return false;
  }
  return true;
}
